import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NeuralCanvas from '../../components/NeuralCanvas';
import CountdownTimer from '../../components/CounterDownTimer/CountdownTimer';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import useIsMobile from '../../hooks/useIsMobile';
import './Home.css';

const Home = ({ onJoinClick, isExpired, onCountdownExpired }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [countdownExpired, setCountdownExpired] = useState(false);

  const handleJoinClick = () => {
    if (countdownExpired || isExpired) {
      return; // No hacer nada si el contador expiró
    }
    
    if (onJoinClick) onJoinClick();

    setTimeout(() => {
      const formElement = document.getElementById('joinForm');
      if (formElement) {
        formElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  };

  const handleCountdownExpired = (expired) => {
    setCountdownExpired(expired);
    if (onCountdownExpired) {
      onCountdownExpired(expired);
    }
  };

  return (
    <>
      <div className="overlay"></div>
      <NeuralCanvas />
      <LanguageSelector className={isMobile ? 'mobile-language-selector' : ''} />
      
      <div className={`home-container ${isMobile ? 'mobile-container' : ''}`} id="landingPage">
        <h1 id="heading" className={isMobile ? 'mobile-heading' : ''}>{t('heading')}</h1>
        <p id="description" className={isMobile ? 'mobile-description' : ''}>{t('description')}</p>
        <CountdownTimer 
          targetDate="April 30, 2026 00:00:00" 
          onExpired={handleCountdownExpired}
        />
        <p id="home-mission" className={isMobile ? 'mobile-description' : ''}>{t('home.mission')}</p>
        <button 
          className={`cta-button ${isMobile ? 'mobile-cta-button' : ''} ${(countdownExpired || isExpired) ? 'disabled' : ''}`} 
          onClick={handleJoinClick}
          disabled={countdownExpired || isExpired}
        >
          {t('join-button')}
        </button>
      </div>
    </>
  );
};

export default Home; 